import React from 'react';

export default () => (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.77273 2.5H18.2273C18.6909 2.5 19 2.81655 19 3.29136V14.3705C19 14.8453 18.6909 15.1618 18.2273 15.1618H10.5L6.48182 19.2769C6.01818 19.7517 5.09091 19.4352 5.09091 18.6438V15.1618H2.77273C2.30909 15.1618 2 14.8453 2 14.3705V3.29136C2 2.81655 2.30909 2.5 2.77273 2.5Z" stroke="currentColor" strokeWidth="1.2" />
  </svg>
)
